export default {
  primary: '#6050DC',
  appBg: '#F7F8FC',
  darkTitle: '#212121'
}
